/* eslint-disable */
export default {
  noResultFoundFor: 'Aucun résultat trouvé pour',
  search: 'Rechercher',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"search"@#@ @source: @#@"Search"@#@
